/**
 * @file index.tsx
 *
 * @fileoverview Wraps children in resume link.
 */

import { Resume } from '~/jobiqo/types/types';
import Link from '~/jobiqo/components/Link';

interface ResumeLinkProps {
  /**
   * The children element.
   */
  children: React.ReactNode;
  /**
   * The resume.
   */
  resume?: Resume;
  /**
   * Whether to render the link as a child.
   */
  asChild?: boolean;
}
export default function ResumeLink({
  resume,
  children,
  asChild,
}: ResumeLinkProps) {
  if (!resume || !resume.user?.id) {
    return <>{children}</>;
  }

  return (
    <Link
      href={{
        pathname: '/resume',
        query: { id: resume.user.id },
      }}
      as={`/resume/${resume.user.id}`}
      asChild={asChild}
    >
      {children}
    </Link>
  );
}

export { ResumeLink };
